var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotifIgnitionOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 22,
    viewBox: "0 0 24 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 23,
    height: 21,
    rx: 5.5,
    fill: "#F0A311",
    fillOpacity: 0.15
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 23,
    height: 21,
    rx: 5.5,
    stroke: "#F0A311"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.63021 18.3994L10.4635 12.6619H6.92188L13.1552 3.67188H13.5402L12.7235 10.1619H16.8902L10.0152 18.3994H9.63021Z",
    fill: "#F0A311"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotifIgnitionOff);
export default __webpack_public_path__ + "static/media/notif-ignition-off.88a8c3ded6f2c4ae622021f4a478379b.svg";
export { ForwardRef as ReactComponent };